import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import PrivacyPage from "@/components/PrivacyPage";
import { CookieConsent } from "@/components/CookieConsent";
import { captureAttribution, initWhatsAppTracking } from "@/lib/tracking";

captureAttribution();
initWhatsAppTracking();

const isPrivacy = window.location.pathname.replace(/\/$/, "") === "/privacidade";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {isPrivacy ? <PrivacyPage /> : <App />}
    <CookieConsent />
  </React.StrictMode>,
);
